import { render, staticRenderFns } from "./reciboDialog.vue?vue&type=template&id=882de130&scoped=true"
import script from "./reciboDialog.vue?vue&type=script&lang=js"
export * from "./reciboDialog.vue?vue&type=script&lang=js"
import style0 from "./reciboDialog.vue?vue&type=style&index=0&id=882de130&prod&scoped=true&media=print&lang=css"
import style1 from "./reciboDialog.vue?vue&type=style&index=1&id=882de130&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882de130",
  null
  
)

export default component.exports